<div class="modal--signer-email">
  <h1 class="modal__header">Signer Information</h1>
  <div>
    <p class="label-basic__text">Will {{ signerFirstName ? signerFirstName : 'the signer' }} own this policy?</p>
    <div>
      <radio-group #hasSigner [valueOptions]="YesNoOptions"></radio-group>
    </div>
    <div class="signer_email">
      <div [hidden]="hasSigner.selectedItem === 'false'">
        <p class="label-basic__text">
          Please enter {{ signerFirstName ? signerFirstName : 'the signer' }}'s email address below
        </p>
        <basic-text-input #signerEmail></basic-text-input>
      </div>
    </div>
  </div>
  <div class="modal__actions modal__actions--inline">
    <button class="button button--blue button--primary modal__button" (click)="confirm()">Done</button>
  </div>
</div>
